import onBlokkliEvent from "./composables/onBlokkliEvent.js";
import useAnimationFrame from "./composables/useAnimationFrame.js";
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount
} from "#imports";
import { eventBus } from "#blokkli/helpers/eventBus";
import { createProgramInfo } from "twgl.js";
export default function(ui) {
  let mouseX = 0;
  let mouseY = 0;
  let iterator = 120;
  const webglSupported = ref(null);
  useAnimationFrame((time) => {
    if (iterator < 1) {
      return;
    }
    iterator--;
    eventBus.emit("animationFrame:before", { time, mouseX, mouseY });
    eventBus.emit("animationFrame", {
      mouseX,
      mouseY,
      fieldAreas: [],
      time
    });
  });
  function onWindowMouseMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }
  onMounted(() => {
    document.body.addEventListener("wheel", requestDraw, { passive: false });
    window.addEventListener("pointermove", onWindowMouseMove, { capture: true });
  });
  onBeforeUnmount(() => {
    document.body.removeEventListener("wheel", requestDraw);
    window.removeEventListener("pointermove", onWindowMouseMove, {
      capture: true
    });
  });
  const requestDraw = () => iterator = 120;
  onBlokkliEvent("select", requestDraw);
  onBlokkliEvent("select:start", requestDraw);
  onBlokkliEvent("select:end", requestDraw);
  onBlokkliEvent("select:toggle", requestDraw);
  onBlokkliEvent("option:update", requestDraw);
  onBlokkliEvent("state:reloaded", requestDraw);
  const dpi = computed(() => {
    if (ui.lowPerformanceMode.value) {
      return 0.5;
    }
    if (ui.isMobile.value) {
      return window.devicePixelRatio;
    }
    return Math.min(window.devicePixelRatio, 2.5);
  });
  function setSharedUniforms(gl, programInfo) {
    const resolution = [ui.viewport.value.width, ui.viewport.value.height];
    gl.uniform2fv(
      gl.getUniformLocation(programInfo.program, "u_resolution"),
      resolution
    );
    const offset = ui.artboardOffset.value;
    gl.uniform1f(
      gl.getUniformLocation(programInfo.program, "u_offset_x"),
      offset.x
    );
    gl.uniform1f(
      gl.getUniformLocation(programInfo.program, "u_offset_y"),
      offset.y
    );
    gl.uniform1f(
      gl.getUniformLocation(programInfo.program, "u_scale"),
      ui.artboardScale.value
    );
    gl.uniform1f(gl.getUniformLocation(programInfo.program, "u_dpi"), dpi.value);
  }
  const registeredPrograms = {};
  function registerProgram(id, gl, shaders) {
    if (!registeredPrograms[id]) {
      registeredPrograms[id] = createProgramInfo(gl, shaders);
    }
    return registeredPrograms[id];
  }
  function setMouseCoords(x, y) {
    mouseX = x;
    mouseY = y;
    iterator = 120;
  }
  function getCanvasElement() {
    const el = document.querySelector("#bk-animation-canvas-webgl");
    if (!(el instanceof HTMLCanvasElement)) {
      throw new TypeError("Failed to locate WebGL canvas.");
    }
    return el;
  }
  return {
    requestDraw,
    gl: function() {
      if (webglSupported.value === false) {
        return;
      }
      const canvas = getCanvasElement();
      const gl = canvas.getContext("webgl2", {
        premultipliedAlpha: true
      });
      if (!gl) {
        webglSupported.value = false;
        return;
      }
      webglSupported.value = true;
      return gl;
    },
    setSharedUniforms,
    dpi,
    registerProgram,
    setMouseCoords,
    webglSupported: computed(() => webglSupported.value),
    getCanvasElement
  };
}
